var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('heading',[_vm._v(_vm._s(_vm.$t("proof.title")))]),_c('v-breadcrumbs',{staticClass:"breadcrumbs",attrs:{"items":_vm.breadcrumbs}}),_c('proofTable',{ref:"proofTable"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }